import React from "react";
import _MessageTemplates from "../../../features/partner/rcs/components/_MessageTemplates";

const MessageTemplates = () => {
  return (
    <div>
      <h2 className="font-semibold">Plantillas de Mensajes RCS</h2>
      <_MessageTemplates />
    </div>
  );
};

export default MessageTemplates;
